import React from "react";
import PropTypes from "prop-types";

import Button from "components/CustomButtons/Button.js";
import TabPanel from "./TabPanel";
import AddIcon from '@mui/icons-material/Add';
import Tooltip from "@mui/material/Tooltip";
import Zoom from "@mui/material/Zoom";

export default function AddPermission(props) {
  const { children, value, index, handleNewPermission, ...other } = props;

  return (
    <Tooltip
      TransitionComponent={Zoom}
      arrow
      interactive
      placement="top"
      title="Nouvelle permission"
    >
      <Button
        style={{
          color: "#FFFFFF",
          backgroundColor: "#91C73C",
          fontWeight: "normal",
          fontWeight: "bold",
          height: "40px",
          fontSize: "0.75rem",
          padding: "5px 15px",
          marginLeft: "-10px",
          marginRight: "10px",
          marginBottom: "13px",
          fontFamily: '"Source Sans Pro",sans-serif',

        }}
        onClick={() => {
          handleNewPermission();
        }}
      >
        <AddIcon fontSize="small" style={{
          marginRight: "6px"
        }}/>
        Nouvelle permission
      </Button>   
    </Tooltip>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};
